/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Count_Sessions_OneInputs */

const en_ui_count_sessions_one = /** @type {(inputs: Ui_Count_Sessions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 session`)
};

const de_ui_count_sessions_one = /** @type {(inputs: Ui_Count_Sessions_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Einheit`)
};

/**
* | output |
* | --- |
* | "1 session" |
*
* @param {Ui_Count_Sessions_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_count_sessions_one = /** @type {((inputs?: Ui_Count_Sessions_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Count_Sessions_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_count_sessions_one(inputs)
	return de_ui_count_sessions_one(inputs)
});